import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetAllMotivationsLibrary,
	adminGetMotivationLibrary,
	adminPatchMotivationLibrary,
	adminPostMotivationLibrary,
	adminDeleteMotivationLibrary,
	resetFocusMotivationLibrary,
	initNewMotivationLibrary,
} from "services/questionLibrary";
import { adminGetAllAnswerOptionLibrary } from "services/answerOptionLibrary";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/Motivations/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import PresentationForm from "features/Admin/Motivations/Forms/PresentationForm";
import ReponsesForm from "features/Admin/Motivations/Forms/ReponsesForm";
import AnswersForm from "features/Admin/Motivations/Forms/AnswersForm";
import * as Yup from "yup";

const schemaValidation = Yup.object().shape({
	code: Yup.string().required("Champ requis"),
	code_comment: Yup.string(),
	adding_free_input: Yup.string(),
	auto_answer: Yup.boolean(),
	free_input_type: Yup.string(),
	label: Yup.string().required("Champ requis"),
	method: Yup.string().required("Champ requis"),
	sil_code: Yup.string().required("Champ requis"),
	number_records: Yup.number(),
	optional_response: Yup.boolean(),
	take_number_before_display: Yup.number().required("Champ requis"),
	auto_select_last_record: Yup.string(),
	group: Yup.string(),
});

class Motivations extends Component {
	constructor(props) {
		super(props);

		this.state = {
			answersFactory: {
				list: this.props.answers.list.data,
				selected: [],
				listLabel: "Liste des réponses",
				selectedLabel: "Réponses sélectionnées",
				tmp: {
					add: [],
					remove: [],
				},
			},
		};
	}

	componentDidMount() {
		this.getAllElements();

		if (this.props.motivations.focus.data !== null) {
			this.setupFactories(this.props.motivations.focus.data);
		}
	}

	setupFactories = (elt) => {
		this.setState({
			answersFactory: {
				list: this.props.answers.list.data
					.map((i) => {
						return { ...i, persisted: false };
					})
					.sort((a, b) => a.code.localeCompare(b.code)),
				selected:
					elt !== undefined && elt !== null && elt.answer_options !== undefined
						? elt.answer_options.map((i) => {
								return { ...i.answer_option, persisted: true, order: i.order, questionAnswerOptionId: i.id };
						  })
						: [],
				listLabel: this.state.answersFactory.listLabel,
				selectedLabel: this.state.answersFactory.selectedLabel,
				tmp: this.state.answersFactory.tmp,
			},
		});
	};

	resetFactories = () => {
		this.setState({
			answersFactory: {
				list: this.state.answersFactory.list.sort((a, b) => a.code.localeCompare(b.code)),
				selected: this.state.answersFactory.selected,
				listLabel: this.state.answersFactory.listLabel,
				selectedLabel: this.state.answersFactory.selectedLabel,
				tmp: {
					add: [],
					remove: [],
				},
			},
		});
	};

	componentWillUnmount() {
		this.props.resetFocusMotivationLibrary();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.motivations.focus.data !== prevProps.motivations.focus.data) {
			this.setupFactories(this.props.motivations.focus.data);
		}
	}

	getAllElements = () => {
		this.props.adminGetAllMotivationsLibrary();
		this.props.adminGetAllAnswerOptionLibrary();
	};

	focusOnElement = (elt) => {
		this.props.adminGetMotivationLibrary(elt);
	};

	onAddClick = () => {
		this.props.initNewMotivationLibrary();
	};

	saveFocus = (values, setSubmitting) => {
		// Handle numbers...

		values.number_records = Number(values.number_records);
		values.take_number_before_display = Number(values.take_number_before_display);

		// Handle answers
		values.answersTmp = {
			add: this.state.answersFactory.tmp.add.map((i) => ({ id: i.id, order: i.order })),
			remove: this.state.answersFactory.tmp.remove.map((i) => ({ id: i.questionAnswerOptionId })),
		};

		values.answersUpdate = this.state.answersFactory.selected;
		values.status = values.status ? "ACTIVE" : "UNACTIVE";
		delete values.answer_options;

		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostMotivationLibrary(values).then(() => {
				this.resetFactories();
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchMotivationLibrary(values).then(() => {
				this.resetFactories();
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteMotivationLibrary(this.props.motivations.focus.data);
	};

	render() {
		let motivation = this.props.motivations.focus.data;
		let { focus, list } = this.props.motivations;
		let newMotivationLibrary = motivation !== null && motivation.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={
						this.props.motivations.list && this.props.motivations.list.data
							? {
									data: this.props.motivations.list.data.map((m) => {
										return { ...m, field: m.status === "UNACTIVE" ? "Désactivées" : "Actives" };
									}),
									loading: this.props.motivations.list.loading,
							  }
							: { data: [], loading: this.props.motivations.list.loading }
					}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="MOTIVATIONS"
					addButtonText="Nouvelle motivation"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.code}
					groupField={"field"}
					focusedEltId={motivation}
				/>

				<ElementFocus element={focus} list={list} entity="Motivations" icon="question circle">
					{motivation !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: motivation.id,
								code: motivation.code || "",
								code_comment: motivation.code_comment || "",
								adding_free_input: motivation.adding_free_input || "",
								auto_answer: Boolean(motivation.auto_answer),
								free_input_type: motivation.free_input_type || "",
								label: motivation.label || "",
								method: motivation.method || "",
								sil_code: motivation.sil_code || "",
								number_records: motivation.number_records || 0,
								optional_response: Boolean(motivation.optional_response),
								take_number_before_display: motivation.take_number_before_display || 0,
								auto_select_last_record: motivation.auto_select_last_record || "",
								group: motivation.group || "",
								systematic: false,
								motivation: true,
								target: motivation.target === "NURSE" || false,
								status: motivation.status === "ACTIVE" || true,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, values, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusMotivationLibrary}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newMotivationLibrary ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newMotivationLibrary && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={2}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>

											<Grid.Column>
												<AdminDataContainer ribbonColor="orange" ribbonLabel="Présentation">
													<PresentationForm errors={errors} />
												</AdminDataContainer>

												<div style={{ height: 20 }}>&nbsp;</div>

												<AdminDataContainer ribbonColor="blue" ribbonLabel="Format">
													<ReponsesForm errors={errors} values={values} />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
										{(values.method === "list_unique" || values.method === "checkbox" || values.method === "radio") && (
											<Grid.Row columns={1}>
												<Grid.Column>
													<AdminDataContainer ribbonColor="grey" ribbonLabel="Réponses">
														<AnswersForm answersFactory={this.state.answersFactory} />
													</AdminDataContainer>
												</Grid.Column>
											</Grid.Row>
										)}
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocWhiteQuestionsAdmin: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		motivations: state.admin.motivations,
		answers: state.admin.answers,
	};
};

const mapDispatchToProps = {
	adminGetAllMotivationsLibrary,
	adminGetMotivationLibrary,
	adminPatchMotivationLibrary,
	adminDeleteMotivationLibrary,
	resetFocusMotivationLibrary,
	adminPostMotivationLibrary,
	initNewMotivationLibrary,
	adminGetAllAnswerOptionLibrary,
};

export default connect(mapStateToProps, mapDispatchToProps)(Motivations);
